import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getProductList = async (data) => {
  return decryptData(
    await axios.get(
      `/getProductList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateStatusOfProduct = async (data) => {
  return decryptData(
    await axios.post(`/updateStatusOfProduct`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getCategoryDropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getCategoryDropdownList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addProduct = async (data) => {
  return decryptData(
    await axios.post(`/addProduct`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getProductListByID = async (data) => {
  return decryptData(
    await axios.get(
      `/getProductListByID?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateProduct = async (data) => {
  return decryptData(
    await axios.post(`/updateProduct`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
